import React from 'react';
import { Icon } from 'semantic-ui-react';

const Loader = () => <Icon className="App-logo loader" name="gift" size="huge" style={{ color: 'navajowhite' }} />;

export default Loader;
